/**
 * Collectible Mapping Configuration
 *
 * Maps decoration types to collectible types.
 * Only decorations with 'top' placement become collectibles.
 */

import { CollectibleType } from '../entities/Collectible';

/**
 * Map of decoration type strings to CollectibleType enum
 * Only includes decorations that should be collectible
 */
export const DECORATION_TO_COLLECTIBLE: Record<string, CollectibleType> = {
  // Zone 1: Forest Floor
  firefly: CollectibleType.FIREFLY,
  'tiny-snail': CollectibleType.SNAIL,
  'small-frog': CollectibleType.FROG,
  butterfly: CollectibleType.BUTTERFLY,
  beetle: CollectibleType.BEETLE,
  dewdrop: CollectibleType.DEWDROP,
  'mushroom-buddy': CollectibleType.MUSHROOM,

  // Zone 2: Tree Canopy
  'small-bird': CollectibleType.BIRD,
  moth: CollectibleType.MOTH,

  // Zone 3: Sky Layers
  'floating-feather': CollectibleType.FEATHER,

  // Zone 4: Starlit Night
  'twinkling-star': CollectibleType.STAR,
  'star-dust': CollectibleType.STARDUST,

  // Zone 5: Golden Summit
  'gold-coin': CollectibleType.COIN,
  'gem-crystal': CollectibleType.GEM,
  'golden-sparkle': CollectibleType.SPARKLE,

  // Zone 6: Cosmic Expanse
  'energy-orb': CollectibleType.ENERGY_ORB,
  'cosmic-particle': CollectibleType.COSMIC,
  'portal-fragment': CollectibleType.PORTAL,
};

/**
 * Check if a decoration type should be collectible
 */
export function isCollectibleDecoration(decorationType: string): boolean {
  return decorationType in DECORATION_TO_COLLECTIBLE;
}

/**
 * Get collectible type from decoration type
 */
export function getCollectibleType(decorationType: string): CollectibleType | null {
  return DECORATION_TO_COLLECTIBLE[decorationType] || null;
}
